import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import useStyles from 'features/setting/treatments/clinic-fees/style'

/** API */
import ClinicFeeApi from 'api/setting/treatments/clinic-fee.api'

/** UTILS || SLICE */
import { submitModal } from 'app/slice/modal.slice'
import { numberFormat, numberOnly } from 'utils/app.utils'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const initStateErrorMessage = {
  CLINIC_FEE_NAME: ``,
  IS_DUPLICATE_CLINIC_FEE_NAME: ``,
  CLINIC_FEE_NAME_STRING_BASE: ``,
  CLINIC_FEE_NAME_STRING_EMPTY: ``,
  CLINIC_FEE_NAME_MAXIMUM_LENGTH: ``,
  CLINIC_FEE_NAME_ANY_REQUIRED: ``,

  CLINIC_FEE_NAME_EN: ``,
  IS_DUPLICATE_CLINIC_FEE_NAME_EN: ``,
  CLINIC_FEE_NAME_EN_STRING_BASE: ``,
  CLINIC_FEE_NAME_EN_STRING_EMPTY: ``,
  CLINIC_FEE_NAME_EN_MAXIMUM_LENGTH: ``,
  CLINIC_FEE_NAME_EN_ANY_REQUIRED: ``,

  CLINIC_FEE_PRICE: ``,
  CLINIC_FEE_PRICE_NUMBER_BASE: ``,
  CLINIC_FEE_PRICE_MAXIMUM_LENGTH: ``,
  CLINIC_FEE_PRICE_NUMBER_EMPTY: ``,
  CLINIC_FEE_PRICE_ANY_REQUIRED: ``
}
export default function ClinicFees() {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [clinicFees, setClinicFees] = useState([])

  const [clinicFeeId, setClinicFeeId] = useState(Number)
  const [clinicFeeName, setClinicFeeName] = useState('')
  const [clinicFeeNameEn, setClinicFeeNameEn] = useState('')
  const [clinicFeePrice, setClinicFeePrice]: any = useState(Number)
  const [clinicFeeStatus, setClinicFeeStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  const loadData = async () => {
    try {
      const resp = await ClinicFeeApi.findAll({
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setClinicFees(resp.data)
      } else {
        setClinicFees([])
      }
    } catch (error) {
      notiError('เกิดข้อผิดพลาด')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  const submit = () => {
    setDisabledSubmit(true)
    if (!clinicFeeName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ CLINIC_FEE_NAME: t('CLINIC_FEE.MESSAGE.CLINIC_FEE_NAME') } })
    }
    if (clinicFeePrice === '') {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ CLINIC_FEE_PRICE: t('CLINIC_FEE.MESSAGE.CLINIC_FEE_PRICE') } })
    }

    dispatch(submitModal())
    ClinicFeeApi.create({ clinicFeeName, clinicFeeNameEn, price: clinicFeePrice })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          resetForm()
          loadData()
          setIsOpen(false)
          notiSuccess(t('CLINIC_FEE.MESSAGE.SUCCESS.CREATE'), '', null, null)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`CLINIC_FEE.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`CLINIC_FEE.MESSAGE.${err.message}`) } })
      })
  }

  const submitEdit = () => {
    setDisabledSubmit(true)
    if (!clinicFeeName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ CLINIC_FEE_NAME: t(`CLINIC_FEE.MESSAGE.CLINIC_FEE_NAME`) } })
    }
    if (clinicFeePrice === '') {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ CLINIC_FEE_PRICE: t('CLINIC_FEE.MESSAGE.CLINIC_FEE_PRICE') } })
    }

    dispatch(submitModal())
    ClinicFeeApi.update(clinicFeeId, {
      clinicFeeName,
      clinicFeeNameEn,
      price: clinicFeePrice,
      status: clinicFeeStatus
    })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          resetForm()
          loadData()
          setIsOpen(false)
          notiSuccess(t(`CLINIC_FEE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`CLINIC_FEE.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`CLINIC_FEE.MESSAGE.${err.message}`) } })
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setClinicFeeId(0)
    setClinicFeeName('')
    setClinicFeeNameEn('')
    setClinicFeePrice(0)
    setClinicFeeStatus('')
    clearErrorMessage()
    setIsOpen(false)
  }

  const onActive = () => {
    if (id) {
      ClinicFeeApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('CLINIC_FEE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('CLINIC_FEE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = async () => {
    if (id) {
      ClinicFeeApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('CLINIC_FEE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('CLINIC_FEE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { clinicFeeId: cfId, clinicFeeName: cfName, clinicFeeNameEn: cfNameEn, price: cfPrice, status: cfStatus } = data
    setClinicFeeId(cfId)
    setClinicFeeName(cfName)
    setClinicFeeNameEn(cfNameEn)
    setClinicFeePrice(cfPrice)
    setClinicFeeStatus(cfStatus)
    setIsOpen(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: t('TABLE.NO') },
    { id: 'clinicFeeName', disablePadding: false, label: t('CLINIC_FEE.TABLE.CELL.CLINIC_FEE_NAME') },
    { id: 'clinicFeeNameEn', disablePadding: false, label: t('CLINIC_FEE.TABLE.CELL.CLINIC_FEE_NAME_EN') },
    { id: 'price', disablePadding: false, label: t('CLINIC_FEE.TABLE.CELL.CLINIC_FEE_PRICE') },
    { id: 'status', disablePadding: false, label: t('CLINIC_FEE.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('CLINIC_FEE.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { clinicFeeId: cfId, clinicFeeName: cfName, clinicFeeNameEn: cfNameEn, price: cfPrice, updatedBy, updatedAt, status: cfStatus } = objData
    const statusBtnActive = cfStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = cfStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled

    const objRenderData = {
      key: cfId,
      id: cfId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: cfName },
        { option: 'TEXT', align: 'left', label: cfNameEn },
        { option: 'TEXT', align: 'right', label: numberFormat(cfPrice) },
        { option: 'STATUS', align: 'center', label: cfStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.clinicFeeName)
    setNameEn(obj.clinicFeeNameEn)
  }

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`CLINIC_FEE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`CLINIC_FEE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { clinicFeeName: name, clinicFeeNameEn: nameEn && `(${nameEn})`, status: t(`CLINIC_FEE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <PageModal
        title={clinicFeeId ? t('CLINIC_FEE.TITLE_UPDATE') : t('CLINIC_FEE.TITLE_CREATE')}
        size='XS'
        isOpen={isOpen}
        handleClose={resetForm}
        onCancel={{ onClick: resetForm, title: t('CLINIC_FEE.BUTTON.CANCEL') }}
        onSubmit={{ onClick: clinicFeeId ? submitEdit : submit, title: t('CLINIC_FEE.BUTTON.SAVE') }}
      >
        <Box display="flex" flexDirection="column" gap="16px">
          {clinicFeeId ? <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
            <SwitchButton onChange={() => setClinicFeeStatus(clinicFeeStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={clinicFeeStatus === 'ACTIVE' ? true : false} />
          </Box> : ''}
          <TextInput
            onChange={(event) => {
              setClinicFeeName(event.target.value)
              clearErrorMessage()
            }}
            value={clinicFeeName}
            label={t('CLINIC_FEE.INPUT.CLINIC_FEE_NAME')}
            helperText={
              errorMessage.CLINIC_FEE_NAME ||
              errorMessage.IS_DUPLICATE_CLINIC_FEE_NAME ||
              errorMessage.CLINIC_FEE_NAME_STRING_BASE ||
              errorMessage.CLINIC_FEE_NAME_STRING_EMPTY ||
              errorMessage.CLINIC_FEE_NAME_MAXIMUM_LENGTH ||
              errorMessage.CLINIC_FEE_NAME_ANY_REQUIRED
            }
            required
          />
          <TextInput
            onChange={(event) => {
              setClinicFeeNameEn(event.target.value)
              clearErrorMessage()
            }}
            value={clinicFeeNameEn}
            helperText={
              errorMessage.CLINIC_FEE_NAME_EN ||
              errorMessage.IS_DUPLICATE_CLINIC_FEE_NAME_EN ||
              errorMessage.CLINIC_FEE_NAME_EN_STRING_BASE ||
              errorMessage.CLINIC_FEE_NAME_EN_STRING_EMPTY ||
              errorMessage.CLINIC_FEE_NAME_EN_MAXIMUM_LENGTH ||
              errorMessage.CLINIC_FEE_NAME_EN_ANY_REQUIRED
            }
            label={t('CLINIC_FEE.INPUT.CLINIC_FEE_NAME_EN')}
          />
          <TextInput
            numberOnly
            onChange={(event) => {
              setClinicFeePrice(numberOnly(event))
              clearErrorMessage()
            }}
            value={clinicFeePrice}
            helperText={
              errorMessage.CLINIC_FEE_PRICE ||
              errorMessage.CLINIC_FEE_PRICE_NUMBER_BASE ||
              errorMessage.CLINIC_FEE_PRICE_MAXIMUM_LENGTH ||
              errorMessage.CLINIC_FEE_PRICE_NUMBER_EMPTY ||
              errorMessage.CLINIC_FEE_PRICE_ANY_REQUIRED
            }
            label={t('CLINIC_FEE.INPUT.CLINIC_FEE_PRICE')}
            required
          />
        </Box>
      </PageModal>
      <HeaderCard text={t('CLINIC_FEE.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={2}>
            <TextInput
              label={t('CLINIC_FEE.SEARCH')}
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={1}>
            <MainButton
              title={t('INPUT.SEARCH')}
              type='primary'
              variant='contained'
              style={{ width: '120px' }}
              onClick={() => {
                setPage(1)
                loadData()
              }} />

          </Grid>
          <Grid item xs={7} textAlign="right">
            <MainButton title={t('CLINIC_FEE.BUTTON.ADD')} disabled={permissions.isCreate.disabled} type='primary' variant='contained' onClick={() => setIsOpen(true)} startIcon={<AddCircleIcon />} />
          </Grid>
        </Grid>

        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={clinicFees.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>
      </Box>
    </Box>
  )
}
